import { render, staticRenderFns } from "./RiskIndexHighlightsDetail.vue?vue&type=template&id=45703b03&scoped=true"
import script from "./RiskIndexHighlightsDetail.vue?vue&type=script&lang=js"
export * from "./RiskIndexHighlightsDetail.vue?vue&type=script&lang=js"
import style0 from "./RiskIndexHighlightsDetail.vue?vue&type=style&index=0&id=45703b03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45703b03",
  null
  
)

export default component.exports